import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const GreenSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 19,
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  '& .MuiSwitch-switchBase': {
    padding: 1,
    '&.Mui-checked': {
      transform: 'translateX(13px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#27c34c',
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 17,
    height: 17,
    boxShadow: 'none',
  },
  '& .MuiSwitch-track': {
    borderRadius: 10,
    backgroundColor: '#bdbdbd',
    opacity: 1,
  },
}));

export default GreenSwitch;